export enum AgGridTableHeaderLocation {
  ADVANCED_FILTER = 'advancedFilter',
  CHART = 'chart',
  COLUMN_DROP = 'columnDrop',
  COLUMN_TOOL_PANEL = 'columnToolPanel',
  CSV = 'csv',
  FILTER_TOOL_PANEL = 'filterToolPanel',
  GROUP_FILTER = 'groupFilter',
  HEADER = 'header',
  MODEL = 'model',
}

export enum AgGridColumnEventType {
  COLUMN_RESIZED = 'columnResized',
}

export enum AgGridColumnEventSource {
  API = 'api',
  GRID_OPTIONS_CHANGED = 'gridOptionsChanged',
  UI_COLUMN_RESIZED = 'uiColumnResized',
}

export enum AgGridFilterOption {
  BLANK = 'blank',
  CONTAINS = 'contains',
  ENDS_WITH = 'endsWith',
  EQUALS = 'equals',
  GREATER_THAN = 'greaterThan',
  GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual',
  IN_RANGE = 'inRange',
  LESS_THAN = 'lessThan',
  LESS_THAN_OR_EQUAL = 'lessThanOrEqual',
  NOT_BLANK = 'notBlank',
  NOT_CONTAINS = 'notContains',
  NOT_EQUAL = 'notEqual',
  RELATIVE_LAST_7_DAYS = 'relativeLast7Days',
  RELATIVE_LAST_30_DAYS = 'relativeLast30Days',
  RELATIVE_LAST_90_DAYS = 'relativeLast90Days',
  RELATIVE_TODAY = 'relativeToday',
  RELATIVE_YESTERDAY = 'relativeYesterday',
  STARTS_WITH = 'startsWith',
}
